export default "__VITE_ASSET__8LCdpof5__"